import { Box } from '@mui/material';
import ChartSection from '../shared/ChartSection';
import DualAxisLine from '../shared/DualAxisLine';
import useNivoTheme from '../shared/useNivoTheme';

export default function TradingVsUnemployment({ data }) {
    const { colors } = useNivoTheme();
    if (!data || data.length === 0) return null;

    const tickValues = data.filter((_, i) => i % 12 === 0).map(d => d.month);

    return (
        <ChartSection
            id="trading-unemployment"
            title="Do they start selling before unemployment rises?"
            subtitle="Congressional buy/sell ratio overlaid with unemployment rate. When Congress turns bearish, does unemployment follow?"
        >
            <Box sx={{ height: 380 }}>
                <DualAxisLine
                    primary={{
                        id: 'Buy/Sell Ratio',
                        color: colors.primary,
                        unit: 'x',
                        data: data.map(d => ({ x: d.month, y: d.buy_sell_ratio })),
                    }}
                    secondary={{
                        id: 'Unemployment %',
                        color: colors.error,
                        unit: '%',
                        data: data.map(d => ({ x: d.month, y: d.unemployment })),
                    }}
                    leftLegend="Buy/Sell Ratio"
                    rightLegend="Unemployment %"
                    tickValues={tickValues}
                    markers={[
                        {
                            axis: 'y',
                            value: 1,
                            lineStyle: { stroke: colors.muted, strokeDasharray: '4 4' },
                            legend: 'Neutral (1:1)',
                            textStyle: { fill: colors.muted, fontSize: 10 },
                        },
                    ]}
                />
            </Box>
        </ChartSection>
    );
}
